import { onCLS, onINP, onLCP, onFCP, onTTFB, type MetricType } from "web-vitals";
import posthog from "posthog-js";
import { posthogApiKey } from "@/config/posthog";

function sendToPostHog(metric: MetricType) {
  if (!posthogApiKey) return;
  posthog.capture("web_vital_measured", {
    vital_name: metric.name,
    vital_value: metric.value,
    vital_rating: metric.rating,
    vital_delta: metric.delta,
    vital_id: metric.id,
    vital_navigationType: metric.navigationType,
  });
}

export function initWebVitals() {
  if (!posthogApiKey) return;
  onCLS(sendToPostHog);
  onINP(sendToPostHog);
  onLCP(sendToPostHog);
  onFCP(sendToPostHog);
  onTTFB(sendToPostHog);
}
